export interface IChatSample {
  type: ESampleType | string;
  // title: string;
  icon: string;
  query: {
    file: {
      id: string;
      name: string;
      url: string;
      content_type: string;
    }[];
    id: string;
    title: string;
    message: string;
  }[];
}

export enum ESampleType {
  file = "file",
  link = "link",
  video = "video",
  image = "image",
  write = "write",
  vqa = "vqa",
  // other = "other",
}
